import { Checklist } from "models/Checklist";
import { createContext, useContext } from "react";
import { Comment } from "models/Comment";

type ChecklistContextProps = {
  children: React.ReactNode;
  checklist: Checklist;
  comments: Comment[];
};

const ChecklistContext = createContext<{ checklist: Checklist; comments: Comment[] } | undefined>(
  undefined
);

const useChecklistContext = () => {
  const context = useContext(ChecklistContext);
  if (!context) {
    throw new Error("useChecklistContext must be used within an ChecklistProvider");
  }
  return context;
};

const ChecklistProvider: React.FC<ChecklistContextProps> = ({ children, checklist, comments }) => {
  return (
    <ChecklistContext.Provider value={{ checklist, comments }}>
      {children}
    </ChecklistContext.Provider>
  );
};

export { ChecklistProvider as default, useChecklistContext };
